import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const GlobalSettingsProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const selectRecord = useCallback(async (props) => {
        await execute({ scope: 'select', url: `GlobalSettings`, method: 'GET', secure: true });
    }, [execute]);

    const updateRecord = useCallback(async (props) => {
        await execute({ scope: 'update', url: `GlobalSettings`, method: 'PUT', payload: props, secure: true });
    }, [execute]);
    
    const value = { selectRecord, updateRecord, data, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useGlobalSettingsStore = () => React.useContext(Context);
